// frontend/src/lib/analytics.js
// Utility helper to safely track events in both Google Analytics (gtag) and PostHog

export const trackEvent = (eventName, params = {}) => {
  try {
    // Google Analytics (gtag.js)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, {
        ...params,
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
    }

    // PostHog (if initialized)
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(eventName, params);
    }
  } catch (error) {
    console.debug('Analytics tracking notice:', error);
  }
};
